<!-- 该文件已废弃，上线后没有问题可以删掉 -->

<template>
  <div id="combat_knockout" v-show="currThemeObj">
    <div class="teamList_area" ref="teamListArea">
      <template v-if="!isNotDataFlag">
        <!-- <span class="groupTitle" v-text="groupTitle"></span> -->
        <div
          class="compreSportsMeet_table_item"
          v-for="group in teamListGroup"
          :key="group.bracket1Code"
        >
          <div class="groupContainer">
            <span
              class="groupHead"
              :style="{
                width: computedTotalColumnWidth(
                  group.data,
                  rollingLimit,
                  numberNoWidthVw
                ),
              }"
            >
              <span
                class="headItem"
                v-for="(phaseItem, phaseIndex) in group.data"
                v-text="phaseItem.stageName"
                :key="phaseItem.stageCode"
                :style="{
                  width: computedColumnWidth(
                    phaseIndex,
                    group.data,
                    rollingLimit,
                    numberNoWidthVw
                  ),
                  paddingLeft: `${phaseIndex === 0 ? numberNoWidthVw : 0}vw`,
                }"
              ></span>
              <span
                v-if="group.analysisItemId"
                class="compreSportsMeet_table_publishBtn"
                @click="formatThemeActJson(group)"
              >
                <svg
                  t="1692698307306"
                  class="publishBtn_icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="9670"
                  width="60%"
                  height="60%"
                >
                  <path
                    d="M853.333333 533.333333a32 32 0 0 1 64 0v266.666667c0 64.8-52.533333 117.333333-117.333333 117.333333H224c-64.8 0-117.333333-52.533333-117.333333-117.333333V256c0-64.8 52.533333-117.333333 117.333333-117.333333h277.333333a32 32 0 0 1 0 64H224a53.333333 53.333333 0 0 0-53.333333 53.333333v544a53.333333 53.333333 0 0 0 53.333333 53.333333h576a53.333333 53.333333 0 0 0 53.333333-53.333333V533.333333z m-42.058666-277.333333l-89.792-95.402667a32 32 0 0 1 46.613333-43.861333l140.544 149.333333C927.861333 286.485333 913.376 320 885.333333 320H724.704C643.029333 320 576 391.210667 576 480v192a32 32 0 1 1-64 0V480c0-123.296 94.784-224 212.704-224h86.570667z"
                    p-id="9671"
                  ></path>
                </svg>
              </span>
            </span>
            <span
              class="matchContainer"
              :style="{
                width: computedTotalColumnWidth(
                  group.data,
                  rollingLimit,
                  numberNoWidthVw
                ),
              }"
            >
              <span
                class="matchColumn"
                v-for="(phaseItem, phaseIndex) in group.data"
                :key="phaseItem.stageCode"
                :style="{
                  width: computedColumnWidth(
                    phaseIndex,
                    group.data,
                    rollingLimit,
                    numberNoWidthVw
                  ),
                }"
              >
                <span
                  v-for="(matchItem, matchIndex) in phaseItem.matches"
                  :key="matchItem.stageCode"
                  class="matchItem"
                  :style="{
                    padding: `${computedPadding(8.4, 1.2, phaseIndex)}vw 0`,
                  }"
                >
                  <span
                    class="matchItemContainer"
                    :style="{
                      height: `${computedHeight(8.4, 1.2, phaseIndex)}vw`,
                    }"
                    @click.stop="
                      goDetail('CSMeetSportDetailScheduleDetail', {
                        sportsId: matchItem.disciplineCode,
                        eventId: matchItem.eventCode,
                        mid: matchItem.scheduleCode,
                      })
                    "
                  >
                    <span class="matchLeftLine" v-if="phaseIndex > 0"></span>
                    <span
                      class="matchCell"
                      :class="phaseIndex === 0 ? 'firstColumn' : ''"
                    >
                      <span
                        class="teamContainer home"
                        :class="matchItem.matchResult === 'W' ? 'isWin' : ''"
                      >
                        <span
                          class="numberNo"
                          :style="{
                            width: `${
                              phaseIndex === 0 ? numberNoWidthVw : 0
                            }vw`,
                          }"
                          v-if="phaseIndex === 0"
                          v-text="2 * matchIndex + 1"
                        ></span>
                        <span
                          class="matchInfor"
                          :style="{
                            width:
                              phaseIndex === 0
                                ? `calc(100% - ${numberNoWidthVw}vw)`
                                : `100%`,
                          }"
                        >
                          <span class="teamInfor">
                            <span class="teamLogo">
                              <img
                                v-if="matchItem.organisation1Logo"
                                :src="matchItem.organisation1Logo"
                              />
                            </span>
                            <template v-if="matchItem.competitorType === 'T'">
                              <span class="singleRowBox">
                                <span
                                  class="teamName"
                                  v-text="
                                    _valNameFormatHandler(
                                      matchItem.organisation1Name,
                                      matchItem.competitor1Code
                                    )
                                  "
                                  @click.stop="
                                    goDetail(
                                      'CSMeetDelegationDetailIndex',
                                      null,
                                      matchItem.organisation1Code
                                    )
                                  "
                                ></span>
                              </span>
                            </template>
                            <template
                              v-else-if="matchItem.competitorType === 'A'"
                            >
                              <span class="singleRowBox">
                                <span
                                  class="singlePlayerName"
                                  v-text="
                                    _valNameFormatHandler(
                                      matchItem.competitor1Names &&
                                        matchItem.competitor1Names[0]
                                        ? matchItem.competitor1Names[0]
                                            .athleteName
                                        : '',
                                      matchItem.competitor1Code
                                    )
                                  "
                                  @click.stop="
                                    goDetail(
                                      'CSMeetPlayerDetailIndex',
                                      null,
                                      matchItem.competitor1Names &&
                                        matchItem.competitor1Names[0]
                                        ? matchItem.competitor1Names[0]
                                            .athleteCode
                                        : ''
                                    )
                                  "
                                ></span>
                              </span>
                            </template>
                            <template
                              v-else-if="matchItem.competitorType === 'D'"
                            >
                              <span class="doublePlayerNames">
                                <span
                                  class="playerItem"
                                  v-for="playerItem in matchItem.competitor1Names"
                                  :key="playerItem.athleteName"
                                  v-text="
                                    _valNameFormatHandler(
                                      playerItem.athleteName,
                                      matchItem.competitor1Code
                                    )
                                  "
                                  @click.stop="
                                    goDetail(
                                      'CSMeetPlayerDetailIndex',
                                      null,
                                      playerItem.athleteCode
                                    )
                                  "
                                ></span>
                              </span>
                            </template>
                          </span>
                          <span
                            class="matchScore"
                            v-text="matchItem.competitor1Result"
                          ></span>
                        </span>
                      </span>
                      <span
                        class="teamContainer away"
                        :class="matchItem.matchResult === 'L' ? 'isWin' : ''"
                      >
                        <span
                          class="numberNo"
                          :style="{
                            width: `${
                              phaseIndex === 0 ? numberNoWidthVw : 0
                            }vw`,
                          }"
                          v-if="phaseIndex === 0"
                          v-text="2 * matchIndex + 2"
                        ></span>
                        <span
                          class="matchInfor"
                          :style="{
                            width:
                              phaseIndex === 0
                                ? `calc(100% - ${numberNoWidthVw}vw)`
                                : `100%`,
                          }"
                        >
                          <span class="teamInfor">
                            <span class="teamLogo">
                              <img
                                v-if="matchItem.organisation2Logo"
                                :src="matchItem.organisation2Logo"
                              />
                            </span>
                            <template v-if="matchItem.competitorType === 'T'">
                              <span class="singleRowBox">
                                <span
                                  class="teamName"
                                  v-text="
                                    _valNameFormatHandler(
                                      matchItem.organisation2Name,
                                      matchItem.competitor2Code
                                    )
                                  "
                                  @click.stop="
                                    goDetail(
                                      'CSMeetDelegationDetailIndex',
                                      null,
                                      matchItem.organisation2Code
                                    )
                                  "
                                ></span>
                              </span>
                            </template>
                            <template
                              v-else-if="matchItem.competitorType === 'A'"
                            >
                              <span class="singleRowBox">
                                <span
                                  class="singlePlayerName"
                                  v-text="
                                    _valNameFormatHandler(
                                      matchItem.competitor2Names &&
                                        matchItem.competitor2Names[0]
                                        ? matchItem.competitor2Names[0]
                                            .athleteName
                                        : '',
                                      matchItem.competitor2Code
                                    )
                                  "
                                  @click.stop="
                                    goDetail(
                                      'CSMeetPlayerDetailIndex',
                                      null,
                                      matchItem.competitor2Names &&
                                        matchItem.competitor2Names[0]
                                        ? matchItem.competitor2Names[0]
                                            .athleteCode
                                        : ''
                                    )
                                  "
                                ></span>
                              </span>
                            </template>
                            <template
                              v-else-if="matchItem.competitorType === 'D'"
                            >
                              <span class="doublePlayerNames">
                                <span
                                  class="playerItem"
                                  v-for="playerItem in matchItem.competitor2Names"
                                  :key="playerItem.athleteName"
                                  v-text="
                                    _valNameFormatHandler(
                                      playerItem.athleteName,
                                      matchItem.competitor2Code
                                    )
                                  "
                                  @click.stop="
                                    goDetail(
                                      'CSMeetPlayerDetailIndex',
                                      null,
                                      playerItem.athleteCode
                                    )
                                  "
                                ></span>
                              </span>
                            </template>
                          </span>
                          <span
                            class="matchScore"
                            v-text="matchItem.competitor2Result"
                          ></span>
                        </span>
                      </span>
                      <span
                        class="matchBaseInfor"
                        :style="{
                          padding:
                            phaseIndex === 0
                              ? '0 0.694vw 0 4.854vw'
                              : '0 0.694vw',
                        }"
                      >
                        <span
                          class="matchDateTime"
                          v-text="
                            `${_valPerFormatHandler(
                              matchItem.formatDate
                            )}${_valPerFormatHandler(matchItem.formatTime)}`
                          "
                        ></span>
                        <span
                          class="matchPhase"
                          v-text="_valPerFormatHandler(phaseItem.stageName)"
                        ></span>
                      </span>
                    </span>
                  </span>
                </span>
              </span>
            </span>
          </div>
        </div>
      </template>
    </div>
    <cup_notData
      v-if="isNotDataFlag && teamListGroup && teamListGroup.length === 0"
      :className="'relativePtb30'"
    ></cup_notData>
  </div>
</template>

<script>
import cup_base_data_mixin from '@mixins/cup_base_data'
import single_findAnalysisItem_data_mixin from '@mixins/single_findAnalysisItem_data'
import cup_notData from '@components/base/NO_DATA.vue'
export default {
  name: 'combat_knockout',
  mixins: [cup_base_data_mixin, single_findAnalysisItem_data_mixin],
  components: {
    cup_notData,
  },
  props: {
    currSportsDetail: {
      type: Object,
      default: () => ({}),
    },
    datas: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  watch: {
    datas: {
      handler(newVal, oldVal) {
        console.debug('combat_knockout datas 重新刷新数据:', newVal, oldVal)
        if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
          if (newVal && newVal.length > 0) {
            let maxColNum = 0
            newVal.forEach((groupItem) => {
              if (
                groupItem &&
                groupItem.data &&
                groupItem.data.length > 0 &&
                groupItem.data.length > maxColNum
              )
                maxColNum = groupItem.data.length
            })
            this.maxColNum = maxColNum
          }
          this.init()
        }
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      isNotDataFlag: true,
      teamListGroup: null,
      numberNoWidthVw: 4.16,
      rollingLimit: 4, // 列数大于等于4时，出现横滑效果
      themeTemplateType: 37,
    }
  },
  created() {
    this.init()
    console.debug('combat_knockout:', this.datas)
  },
  methods: {
    init() {
      this.makeDatas()
      this.makeAnalysisItemParams(this.themeTemplateType)
    },
    makeAnalysisItemParams(themeTemplateType) {
      // 每个页面单独设置不同函数
      this.findAnalysisItemParams = {
        sportType: 'compreSportsMeet',
        templateType: themeTemplateType,
        cid: this.currCid,
        sid: this.currSid,
        did: 0,
        eid: 0,
        pid: 0,
        mid: 0,
      }
      if (this.initSingleFindAnalysisItem) {
        this.initSingleFindAnalysisItem(this.findAnalysisItemParams)
      }
    },
    findAnalysisItemCallback(resData) {
      // let themeAnalysisItemIdArr = []
      console.debug('resData:', resData)
      let jsonArr = []
      if (resData && resData.length > 0) {
        this.themeList = resData.map((item) => {
          // themeAnalysisItemIdArr.push(item.analysisItemId)
          // console.debug(`aa: ${item}`)
          jsonArr.push(item.json)
          item.actJson = JSON.parse(item.json)
          item.renderData = null
          return item
        })
        this.themeItem = this.themeList[0]
        this.shareDataAddThemeItem(this.themeItem)
      } else {
        this.themeList = []
        this.themeItem = null
      }
    },
    shareDataAddThemeItem(themeItem) {
      if (!this.isNotDataFlag && this.teamListGroup.length > 0 && themeItem) {
        console.debug('this.teamListGroup 1:', this.teamListGroup)
        this.teamListGroup = this.teamListGroup.map((orginTableItem) => {
          const groupTitle = themeItem.analysisItemName
          let singleTableTheme = {
            analysisItemId: themeItem.analysisItemId,
            title: `${this.currSportsDetail.sportsName} · ${this.currSportsDetail.eventName}-${orginTableItem.bracket1Name}${groupTitle}`,
          }
          return Object.assign(orginTableItem, singleTableTheme)
        })
        console.debug('this.teamListGroup:', this.teamListGroup)
      }
    },
    formatThemeActJson(table) {
      if (!this.themeItem) return
      // 主题不同，有些地方需要特殊处理
      // 传参组id
      let keyArrActJson = []
      let newThemeItem = JSON.parse(JSON.stringify(this.themeItem))
      newThemeItem.sportsId = newThemeItem.disciplineId
      newThemeItem.title = table.title
      newThemeItem.sportsId = this.currSportsDetail.sportsId
      newThemeItem.eventId = this.currSportsDetail.eventId
      newThemeItem.actJson = JSON.parse(newThemeItem.json)
      keyArrActJson = Object.keys(newThemeItem.actJson)
      keyArrActJson.forEach((keyItem) => {
        newThemeItem.actJson[keyItem] = table[keyItem]
      })
      console.debug('newThemeItem:', newThemeItem, table, this.teamListGroup)
      this.clickPublicTheme(newThemeItem)
    },
    clickPublicTheme(themeItem) {
      // 分享主题
      let newThemeItem = themeItem
      console.debug('newThemeItem:', newThemeItem)
      // 需要加【篮球-预赛B组积分榜】
      newThemeItem.analysisItemName = newThemeItem.title
      window.mixtmtBase_eventBus.$emit('publicThemeDialogEvent', {
        flag: true,
        themeItem: newThemeItem,
      })
    },
    computedPadding(initHeightVw, initSpace, index) {
      // initSpace 值的就是 .matchItem 中的 margin-bottom 值
      // [(8.4*0+1.2*0)/2,(8.4*1+1.2*0)/2,(8.4*2+1.2*1)/2,(8.4*4+1.2*3)/2,(8.4*8+1.2*7)/2,...]
      let paddingTop =
        (initHeightVw * (index === 0 ? index : Math.pow(2, index - 1)) +
          initSpace *
            (index === 0
              ? index
              : Math.pow(2, index - 1) === 0
              ? Math.pow(2, index - 1)
              : Math.pow(2, index - 1) - 1)) /
        2

      return paddingTop
    },
    computedHeight(initHeightVw, initSpace, index) {
      // [(8.4*1+1.2*0),(8.4*1+1.2*1),(8.4*2+1.2*2),(8.4*4+1.2*4),(8.4*8+1.2*8),...]
      let height =
        initHeightVw * (index === 0 ? 1 : Math.pow(2, index - 1)) +
        initSpace * (index === 0 ? index : Math.pow(2, index - 1))

      return height
    },
    computedColumnWidth(index, group, rollingLimt, numberNoWidthVw) {
      // 大于等于rollingLimt值时，100%展示3列半；否则就按照 maxColNum 的列数渲染
      let columnLength = this.maxColNum
      if (this.maxColNum >= rollingLimt) {
        columnLength = 3.5
      }

      let columnWidthVw =
        index === 0
          ? `calc((100vw - 9.722vw - 9.722vw - ${numberNoWidthVw}vw) / ${columnLength} + ${numberNoWidthVw}vw)`
          : `calc((100vw - 9.722vw - 9.722vw - ${numberNoWidthVw}vw) / ${columnLength})`
      return columnWidthVw
    },
    computedTotalColumnWidth(group, rollingLimt, numberNoWidthVw) {
      let columnLength = this.maxColNum
      if (this.maxColNum >= rollingLimt) {
        columnLength = 3.5
      }
      return `calc(((100vw - 9.722vw - 9.722vw - ${numberNoWidthVw}vw) / ${columnLength}) * ${group.length} + ${numberNoWidthVw}vw)`
    },
    makeDatas() {
      if (this.datas && this.datas.length > 0) {
        this.isNotDataFlag = false
      } else {
        this.isNotDataFlag = true
        this.teamListGroup = []
      }
      if (!this.isNotDataFlag) {
        this.teamListGroup = this.datas
      }
      console.debug('datas:', this.datas)
    },
    _valNameFormatHandler(val, state) {
      // 处理是显示名字还是待定还是轮空
      if (state === 'NOCOMP') {
        return '-'
      } else if (!state) {
        return '待定'
      } else {
        return val
      }
    },
    _valPerFormatHandler(val, ceil) {
      let data
      if (val === undefined || val === null || val === '' || val === ' ') {
        return '-'
      }
      data = `${val}${ceil ? ceil : ''}`
      return data
    },
    goDetail(routerName, item, id) {
      console.debug(routerName, item, this.isBroadCastList)
      if (this.isBroadCastList || (!item && !id)) return
      let query = {}
      if (routerName == 'CSMeetPlayerDetailIndex') {
        query.playerId = item ? item.player_id : id
      }
      if (routerName == 'CSMeetDelegationDetailIndex') {
        query.delegationId = item ? item.team_id : id
      }
      if (routerName == 'CSMeetSportDetailScheduleDetail') {
        query = {
          cid: this.currCid,
          sid: this.currSid,
          sportsId: item.sportsId,
          eventId: item.eventId,
          mid: item.mid,
        }
      }
      this.openNewWeb(this.$router, `${routerName}_${this.currCid}`, query)
    },
  },
}
</script>

<style lang="scss" scoped>
#combat_knockout {
  padding-bottom: 2.778vw;
  .teamList_area {
    width: 100%;
    padding: 2.083vw 0 0 0;
    .groupTitle {
      display: block;
      padding-bottom: 0.972vw;
      font-size: 1.388vw;
      line-height: 1.944vw;
      font-weight: bold;
      color: var(--mixtmt_greyColor3);
    }
  }
  .compreSportsMeet_table_item {
    width: 100%;
    position: relative;
    padding-bottom: 2.083vw;
    overflow-x: auto;
    .compreSportsMeet_table_publishBtn {
      position: absolute;
      right: 0;
      top: 0;
      z-index: 2;
      width: 2.788vw;
      height: 2.788vw;
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      svg.publishBtn_icon {
        fill: var(--mixtmt_whiteColor);
      }
    }
    .groupContainer {
      min-width: 100%;
      height: auto;
    }
    .groupHead {
      position: relative;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      min-width: 100%;
      height: 2.778vw;
      background-color: rgba(125, 130, 187, 1);
      .headItem {
        width: auto;
        font-size: 1.1vw;
        text-align: center;
        color: var(--mixtmt_whiteColor);
      }
    }
    .matchContainer {
      width: auto;
      height: auto;
      min-width: 100%;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: flex-start;
      .matchColumn {
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-direction: column;
        width: auto;
        height: auto;
        .matchItem {
          width: 100%;
          margin-bottom: 1.2vw;
          &:first-child {
            margin: 1.2vw 0;
          }
          .matchItemContainer {
            display: block;
            position: relative;
            width: 100%;
            height: 8.4vw;
            border-radius: 0 0.416vw 0.416vw 0;
            transition: all 0.3s linear;
            overflow: hidden;
            .matchLeftLine {
              display: block;
              position: absolute;
              left: 0;
              top: 0;
              z-index: 5;
              width: 1.388vw;
              height: 100%;
              &::before {
                content: '\20';
                position: absolute;
                left: 0;
                top: 0;
                z-index: 2;
                width: 0.694vw;
                height: 100%;
                border: 1px solid var(--mixtmt_greyColor5);
                border-left: 1px solid transparent;
                border-radius: 0 0.612vw 0.612vw 0;
                pointer-events: none;
                transition: all 0.3s linear;
              }
              &::after {
                content: '\20';
                position: absolute;
                right: 0;
                top: 50%;
                z-index: 2;
                width: 0.694vw;
                height: 1px;
                background-color: var(--mixtmt_greyColor5);
                transform: translateY(-50%);
                pointer-events: none;
                transition: all 0.3s linear;
              }
            }
          }
          .matchCell {
            display: block;
            position: absolute;
            top: 50%;
            left: 1.388vw;
            z-index: 10;
            width: calc(100% - 1.388vw);
            height: 8.4vw;
            border: 1px solid var(--mixtmt_greyColor5);
            border-radius: 0.416vw;
            transform: translateY(-50%);
            &.firstColumn {
              left: 0;
              width: 100%;
            }
          }
          .teamContainer {
            position: absolute;
            left: 0;
            z-index: 10;
            width: 100%;
            display: flex;
            display: -webkit-flex;
            justify-content: flex-start;
            align-items: center;
            color: var(--mixtmt_greyColor3);
            &.home {
              top: 0.694vw;
            }
            &.away {
              bottom: 0.694vw;
            }
            &.isWin {
              .matchInfor {
                .matchScore {
                  color: var(--mixtmt_whiteColor);
                  background-color: rgba(48, 49, 91, 1);
                }
              }
            }
            .numberNo {
              width: 10%;
              font-size: 1.11vw;
              text-align: center;
            }
            .matchInfor {
              width: 100%;
              display: flex;
              display: -webkit-flex;
              justify-content: space-between;
              align-items: center;
              padding: 0 0.694vw;
            }
            .teamInfor {
              width: 100%;
              display: flex;
              display: -webkit-flex;
              justify-content: flex-start;
              align-items: center;
              width: calc(100% - 4.62vw + 0.694vw);
              .teamLogo {
                position: relative;
                width: 2.916vw;
                height: 1.944vw;
                overflow: hidden;
                background-color: var(--mixtmt_greyColor0);
                &:before {
                  content: '\20';
                  position: absolute;
                  left: 0;
                  top: 0;
                  z-index: 2;
                  width: 100%;
                  height: 100%;
                  border: 1px solid var(--mixtmt_greyColor5);
                }
                img {
                  display: block;
                  width: 100%;
                  height: 100%;
                  object-fit: contain;
                }
              }
              .singleRowBox {
                width: calc(100% - 2.916vw);
                display: flex;
                display: -webkit-flex;
                justify-content: flex-start;
                align-items: center;
                .teamName,
                .singlePlayerName {
                  width: auto;
                  max-width: 100%;
                  padding-left: 0.694vw;
                  font-size: 0.972vw;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
              }
              .doublePlayerNames {
                display: flex;
                display: -webkit-flex;
                justify-content: flex-start;
                align-items: flex-start;
                flex-direction: column;
                width: calc(100% - 2.916vw);
                padding-left: 0.694vw;
                .playerItem {
                  position: relative;
                  max-width: 100%;
                  width: auto;
                  text-align: left;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  overflow: hidden;
                }
              }
            }
            .matchScore {
              max-width: calc(4.62vw + 0.694vw);
              min-width: calc(2.778vw);
              width: auto;
              padding: 0 0.278vw;
              font-weight: bold;
              text-align: right;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              color: var(--mixtmt_greyColor3);
              background-color: var(--mixtmt_greyColor7);
            }
          }
          .matchBaseInfor {
            position: absolute;
            top: 50%;
            right: 0;
            z-index: 20;
            width: 100%;
            transform: translateY(-50%);
            display: flex;
            display: -webkit-flex;
            justify-content: flex-start;
            align-items: center;
            /* padding: 0 0.694vw; */
            .matchDateTime,
            .matchPhase {
              font-size: 0.833vw;
              color: var(--mixtmt_greyColor6);
              font-weight: bold;
            }
            .matchPhase {
              padding-left: 0.694vw;
            }
          }
        }
      }
    }
  }
}
.mixtmt_pc #combat_knockout {
  .compreSportsMeet_table_item {
    .groupContainer {
      .groupHead {
        .compreSportsMeet_table_publishBtn {
          cursor: pointer;
          &:hover {
            svg.publishBtn_icon {
              fill: var(--mixtmt_greyColor4);
            }
          }
        }
      }
    }
    .matchContainer {
      .matchColumn {
        .matchItem {
          .matchItemContainer .matchCell {
            &:hover {
              background-color: rgba(210, 160, 195, 1);
              border-radius: 0.416vw;
              cursor: pointer;
              &::before {
                border: 1px solid rgba(125, 130, 187, 1);
                border-radius: 0.416vw;
              }
              .teamContainer {
                color: var(--mixtmt_whiteColor);
                &.isWin {
                  .matchScore {
                    color: var(--mixtmt_whiteColor);
                    background-color: rgba(48, 49, 91, 1);
                  }
                }
                .matchScore {
                  color: var(--mixtmt_whiteColor);
                  background-color: var(--mixtmt_greyColor9);
                }
                .teamInfor {
                  .teamName,
                  .singlePlayerName {
                    &:hover {
                      text-decoration: underline;
                    }
                  }
                  .doublePlayerNames {
                    .playerItem {
                      &:hover {
                        text-decoration: underline;
                      }
                    }
                  }
                }
              }
              .matchBaseInfor {
                .matchDateTime,
                .matchPhase {
                  color: var(--mixtmt_whiteColor);
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
